import React, { useEffect, useState } from "react";
import Circlebtn from "../components/Circlebtn";
import AccountGroupCard from "../components/AccountGroupCard";
import MainModal from "../components/MainModal";
import AddAccount, { ChooseGroup } from "../components/AddAccount";
import SelectVoice from "../components/SelectVoice";
import { CirclesThreeIcon, PlusIcon } from "../assets/icons/Icons";
import { CardProfileSkeletonLoader } from "../components/CardSkeletonLoader";

const Accounts = () => {
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const [showVoiceModal, setShowVoiceModal] = useState<boolean>(false);
  const [showChooseGroup, setShowChooseGroup] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);
  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">SMA - Groups</h1>
        <div className="flex items-center gap-2">
          <Circlebtn onClick={() => setShowAccountModal(true)} icon={<PlusIcon />} className="w-8 h-8 bg-white" />
          <Circlebtn icon={<CirclesThreeIcon />} className="w-8 h-8 bg-white" />
        </div>
      </div>
      <p className="text-[#9392A2] mt-4 text-xs font-medium tracking-tight">Statistics</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">150</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Overall profiles</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">734,235</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Overall followers</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">76</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts scheduled</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">1,322</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts published</p>
        </div>
      </div>
      <p className="text-[#9392A2] mt-10 mb-3 text-xs font-medium tracking-tight">5 account groups</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
            [...Array(6)].map((_, index) => <CardProfileSkeletonLoader key={index} />) :
            [...Array(6)].map((_, index) => <AccountGroupCard key={index} />)
        }
      </div>
      {
        showAccountModal &&
        <MainModal
          subLabel="Step 1 of 3"
          setShowModal={setShowAccountModal}
        >
          <AddAccount showNext={() => {
            setShowAccountModal(false);
            setShowChooseGroup(true);
          }} />
        </MainModal>
      }
      {
        showChooseGroup &&
        <MainModal
          subLabel="Step 2 of 3"
          setShowModal={setShowChooseGroup}
        >
          <ChooseGroup
            showPrev={() => {
              setShowChooseGroup(false);
              setShowAccountModal(true);
            }}
            showNext={() => {
              setShowChooseGroup(false);
              setShowVoiceModal(true);
            }}
          />
        </MainModal>
      }
      {
        showVoiceModal &&
        <MainModal
          label="Select voice"
          setShowModal={setShowVoiceModal}
        >
          <SelectVoice />
        </MainModal>
      }
    </>
  );
};

export default Accounts;